import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Tile,
  TileGroup,
  Typography,
} from '@one-thd/sui-atomic-components';
import React, { ChangeEvent } from 'react';
import {
  userTileOptions,
  FILTER_DOT_BASE_CLASS_NAME,
} from '../../../constants/order-filter';
import { UserFilterSettings } from '../../../models/order-filter';

interface IOrderFilterUserSectionProps {
  showDot: boolean;
  userView?: string;
  username: string;
  setFilterSettings: React.Dispatch<React.SetStateAction<UserFilterSettings>>;
}

export const OrderFilterUserSection = ({
  showDot,
  userView,
  username,
  setFilterSettings,
}: IOrderFilterUserSectionProps) => {
  return (
    <div className="sui-relative sui-border-b-1 sui-border-solid sui-border-strong">
      {showDot && (
        <div className={`${FILTER_DOT_BASE_CLASS_NAME} sui-top-[30px]`} />
      )}
      <Accordion noBorders defaultExpanded>
        <AccordionHeader aria-controls="accordion1-content">
          User
        </AccordionHeader>
        <AccordionBody>
          <div className="sui-mb-[12px]">
            <TileGroup
              value={userView}
              onChange={(
                _event: ChangeEvent<HTMLInputElement>,
                value: string,
              ) => {
                if (value) {
                  setFilterSettings((prevState) => ({
                    ...prevState,
                    userView: value,
                  }));
                }
              }}
              aria-label="user filter"
              orientation="vertical"
            >
              {userTileOptions(username).map((option) => (
                <Tile
                  key={option.value}
                  value={option.value}
                  aria-label={option.label}
                >
                  <Typography className="sui-mr-auto">
                    {option.label}
                  </Typography>
                </Tile>
              ))}
            </TileGroup>
          </div>
        </AccordionBody>
      </Accordion>
    </div>
  );
};
